import dayjs from "dayjs";

const KST_INSTANT_PATTERN = "YYYY-MM-DDTHH:mm:ss.SSSZ";

// 백엔드로 전송할 절대 시각을 KST offset 포함 ISO 8601 문자열로 직렬화한다.
// `@toss/date.kstFormat(date, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")` 와 동일한 character 출력을 보장한다.
//
// 사전 조건: `_app.tsx` 에서 `dayjs.extend(utc)` + `dayjs.extend(timezone)` 등록 완료.
export function toBackendKstInstant(date: Date = new Date()): string {
  return dayjs(date).tz("Asia/Seoul").format(KST_INSTANT_PATTERN);
}
